import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';
import { isSpaceOrEnterKey } from '../../utils/keyboard.js';
import { CloseButton } from '../CloseButton/CloseButton.js';
import { IconButton } from '../IconButton/IconButton.js';
import '../Icons/Add.js';
import '../Icons/Application.js';
import '../Icons/AppStore.js';
import '../Icons/Arrow.js';
import '../Icons/At.js';
import '../Icons/Attach.js';
import '../Icons/Bank.js';
import '../Icons/Battery.js';
import '../Icons/Bell.js';
import '../Icons/Blocked.js';
import '../Icons/Calendar.js';
import '../Icons/Card.js';
import '../Icons/CaretDown.js';
import '../Icons/CaretLeft.js';
import '../Icons/CaretRight.js';
import '../Icons/CaretUp.js';
import '../Icons/Checkbox.js';
import '../Icons/CheckboxChecked.js';
import '../Icons/CheckboxIndeterminate.js';
import '../Icons/ChevronLeft.js';
import ChevronRight from '../Icons/ChevronRight.js';
import '../Icons/Company.js';
import '../Icons/Copy.js';
import '../Icons/Currency.js';
import '../Icons/Customers.js';
import '../Icons/Dash.js';
import '../Icons/Dashboard.js';
import '../Icons/DirectionDown.js';
import '../Icons/DirectionUp.js';
import '../Icons/Document.js';
import '../Icons/DoubleChevronLeft.js';
import '../Icons/DoubleChevronRight.js';
import '../Icons/DoubleDirectionDown.js';
import '../Icons/DoubleDirectionUp.js';
import '../Icons/Download.js';
import '../Icons/Edit.js';
import '../Icons/ExclamationMark.js';
import '../Icons/ExclamationMarkFilled.js';
import '../Icons/ExternalLink.js';
import '../Icons/EyeClosed.js';
import '../Icons/EyeOpen.js';
import '../Icons/Fingerprint.js';
import '../Icons/Folder.js';
import '../Icons/Forever.js';
import '../Icons/Funnel.js';
import '../Icons/GooglePlay.js';
import '../Icons/Iban.js';
import '../Icons/Id.js';
import '../Icons/Info.js';
import '../Icons/InfoFilled.js';
import '../Icons/Instant.js';
import '../Icons/Ip.js';
import '../Icons/Link.js';
import '../Icons/List.js';
import '../Icons/Mail.js';
import '../Icons/Menu.js';
import '../Icons/Message.js';
import '../Icons/MessageDot.js';
import '../Icons/Onboarding.js';
import '../Icons/Padlock.js';
import '../Icons/PadlockOpen.js';
import '../Icons/Percent.js';
import '../Icons/Play.js';
import '../Icons/PowerOff.js';
import '../Icons/ProcessCompleted.js';
import '../Icons/ProcessCountEight.js';
import '../Icons/ProcessCountFive.js';
import '../Icons/ProcessCountFour.js';
import '../Icons/ProcessCountNineAndMore.js';
import '../Icons/ProcessCountOne.js';
import '../Icons/ProcessCountSeven.js';
import '../Icons/ProcessCountSix.js';
import '../Icons/ProcessCountThree.js';
import '../Icons/ProcessCountTwo.js';
import '../Icons/ProcessFailed.js';
import '../Icons/ProcessInProgress.js';
import '../Icons/ProcessNotStarted.js';
import '../Icons/ProcessPartialInProgress.js';
import '../Icons/ProcessPaused.js';
import '../Icons/Profile.js';
import '../Icons/Progress.js';
import '../Icons/Provider.js';
import '../Icons/QuestionMark.js';
import '../Icons/QuestionMarkFilled.js';
import '../Icons/Remove.js';
import '../Icons/Repeat.js';
import '../Icons/Reset.js';
import '../Icons/RoundArrow.js';
import '../Icons/RoundArrowFilled.js';
import '../Icons/RoundCheckOutlined.js';
import '../Icons/RoundCheckOutlinedFilled.js';
import '../Icons/RoundClose.js';
import '../Icons/RoundCloseFilled.js';
import '../Icons/RoundLeft.js';
import '../Icons/RoundLeftFilled.js';
import '../Icons/RoundMinus.js';
import '../Icons/RoundMinusFilled.js';
import '../Icons/RoundPlus.js';
import '../Icons/RoundPlusFilled.js';
import '../Icons/RoundRight.js';
import '../Icons/RoundRightFilled.js';
import '../Icons/Settings.js';
import '../Icons/SettingsCog.js';
import '../Icons/Shield.js';
import '../Icons/StarFilled.js';
import '../Icons/StarOutlined.js';
import '../Icons/Success.js';
import '../Icons/Timer.js';
import '../Icons/Trash.js';
import '../Icons/Upload.js';
import '../Icons/User.js';
import '../Icons/VerticalDots.js';
import '../Icons/World.js';
import '../Icons/Wrench.js';
import '../Icons/Zoom.js';
import { SIDEBAR_ITEM_COLORS } from './constants.js';

const TEST_IDS = {
    closeButton: "sidebar-select-customer-close-button",
    expandButton: "sidebar-select-customer-expand-button",
    label: "sidebar-select-customer-label",
};
function SelectCustomer({ onClick, customerLabel, label, isActive, onRemoveClick, sxWrapper, expandIcon = jsx(ChevronRight, {}), "data-testid": dataTestId, }) {
    const handleWrapperKeyDown = (event) => {
        if (isSpaceOrEnterKey(event)) {
            event.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    };
    const handleIconKeyDown = (event) => {
        if (isSpaceOrEnterKey(event)) {
            event.preventDefault();
            handleIconClick === null || handleIconClick === void 0 ? void 0 : handleIconClick(event);
        }
    };
    const handleIconClick = (event) => {
        event.stopPropagation();
        onRemoveClick === null || onRemoveClick === void 0 ? void 0 : onRemoveClick();
    };
    return (jsxs(Wrapper, { "$isActive": isActive, "data-testid": dataTestId, sx: sxWrapper, tabIndex: 0, onClick: onClick, onKeyDown: handleWrapperKeyDown, children: [jsxs(LabelWrapper, { children: [jsx(Label, { children: label }), jsx(CustomerLabel, { "data-testid": TEST_IDS.label, noWrap: true, children: customerLabel })] }), !isActive ? (jsx(IconButton, { "data-testid": TEST_IDS.expandButton, variant: "lightgrey", children: expandIcon })) : (jsx(CloseButton, { "data-testid": TEST_IDS.closeButton, variant: "lightgrey", onClick: handleIconClick, onKeyDown: handleIconKeyDown }))] }));
}
const Wrapper = styled("div")(({ theme, $isActive }) => (Object.assign({ alignItems: "center", backgroundColor: theme.palette.dui10, cursor: "pointer", display: "flex", justifyContent: "space-between", padding: theme.spacing(2, 3), "&:hover": {
        backgroundColor: SIDEBAR_ITEM_COLORS.hover,
    }, "&:active": {
        backgroundColor: theme.palette.dui15,
    } }, ($isActive && {
    backgroundColor: SIDEBAR_ITEM_COLORS.active,
    "&:hover": {
        backgroundColor: SIDEBAR_ITEM_COLORS.activeHover,
    },
    "&:active": {
        backgroundColor: SIDEBAR_ITEM_COLORS.hover,
    },
}))));
const LabelWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    color: theme.palette.text.dmedium,
    overflow: "hidden",
}));
const Label = styled(Typography)(({ theme }) => ({
    fontSize: 12,
    fontWeight: 300,
    lineHeight: "16px",
    color: theme.palette.text.dhigh,
}));
const CustomerLabel = styled(Typography)(({ theme }) => ({
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.text.dhigh,
}));

export { SelectCustomer };
//# sourceMappingURL=SelectCustomer.js.map
